import { useEffect } from "react";
import { PulseWaveLoader } from "./PulseWaveLoader.js";

const BOOT_SPLASH_ID = "boot-splash";

/** Remove the inline HTML splash once React has painted the same screen. */
export function dismissBootSplash(): void {
  document.getElementById(BOOT_SPLASH_ID)?.remove();
}

type PwaSplashLoaderProps = {
  message?: string;
};

export function PwaSplashLoader({ message = "Loading…" }: PwaSplashLoaderProps) {
  useEffect(() => {
    dismissBootSplash();
  }, []);

  return (
    <div className="pwa-splash" aria-busy="true" aria-live="polite">
      <div className="pwa-splash-inner">
        <img
          className="pwa-splash-icon"
          src="/icons/icon.svg"
          alt=""
          width={72}
          height={72}
          decoding="async"
        />
        <p className="pwa-splash-title">Defibrillator</p>
        <PulseWaveLoader className="pwa-splash-wave" />
        <p className="pwa-splash-status">{message}</p>
      </div>
    </div>
  );
}
